import { lazy } from 'react'
import { Route } from 'react-router-dom'
import Unprotected from '@/routes/Unprotected'
import PATHS from '@/routes/paths'

const SignInPage = lazy(() => import('@/pages/Auth/SignIn'))

/** @returns {import('react').ReactElement[]} */
export default function authRoutes() {
  return [
    <Route
      key="sign-in"
      path={PATHS.SIGN_IN}
      element={
        <Unprotected>
          <SignInPage />
        </Unprotected>
      }
    />,
  ]
}
